import { Box, Flex, HStack, Tag, Text } from '@chakra-ui/react';
import { GlobalSearchSupplierItem } from '@texas/api/endpoints/search/searchApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import {
  BranchIdentifier,
  getBranchColor,
} from '@texas/utils/helpers/texas/branchHelpers';
import { useTranslation } from 'react-i18next';

interface Props {
  supplier: GlobalSearchSupplierItem;
  onResultClick: () => void;
}

export function SupplierItem({ supplier, onResultClick }: Props) {
  const { t } = useTranslation();

  return (
    <AngularNavLink
      to="supplier"
      navobj={{ supplierId: supplier.id }}
      onClick={onResultClick}
      p={2}
      borderRadius="md"
      _hover={{
        bg: 'whiteAlpha.100',
        _light: { bg: 'blackAlpha.100' },
      }}
      textDecoration="none"
    >
      <Box>
        <HStack>
          <Text fontWeight="bold">{supplier.name}</Text>
          {supplier.archived && (
            <Tag size="sm" colorScheme="orange">
              {t('general.archived')}
            </Tag>
          )}
        </HStack>
        {supplier.branchInfo.length > 0 && (
          <Flex mt={1} gap={1} flexWrap="wrap">
            {supplier.branchInfo.map((b) => (
              <Tag
                key={`${b.branchErpId}-${b.supplierNumber}`}
                size="sm"
                bg={getBranchColor(
                  b.branchErpId.toUpperCase() as BranchIdentifier,
                )}
                color="white"
              >
                {b.branchErpId}: {b.supplierNumber}
              </Tag>
            ))}
          </Flex>
        )}
      </Box>
    </AngularNavLink>
  );
}
